"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const HTMLDialogElementCompatibility_1 = require("@/client/components/HTMLDialogElementCompatibility");
const dialog_polyfill_1 = __importDefault(require("dialog-polyfill"));
exports.default = (0, vue_1.defineComponent)({
    name: 'ConfirmDialog',
    props: {
        message: {
            type: String,
            required: true,
        },
        enableDontShowAgainCheckbox: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            hide: false,
            shown: false,
        };
    },
    watch: {
        hide() {
            this.$emit('hide', this.hide);
        },
    },
    computed: {
        typedRefs() {
            return this.$refs;
        },
    },
    methods: {
        accept() {
            this.$emit('accept');
        },
        dismiss() {
            this.$emit('dismiss');
        },
        show() {
            this.shown = true;
            (0, HTMLDialogElementCompatibility_1.showModal)(this.typedRefs.dialog);
        },
    },
    mounted() {
        if (!(0, HTMLDialogElementCompatibility_1.windowHasHTMLDialogElement)())
            dialog_polyfill_1.default.registerDialog(this.typedRefs.dialog);
    },
});
